import React from "react";
import dynamic from "next/dynamic";

const IconBoxCardWithImageBelow = dynamic(() =>
  import("@/components/common/card/IconBoxCardWithImageBelow")
);

import { getSlugURL, getClassForRenderCourseCard } from "@/utils/functions";

const TwoColumnIconBoxCardWithImage = (props) => {
  const { pageBoxesList, labelsList } = props;

  let cardClassList = getClassForRenderCourseCard();
  return (
    <>
      {pageBoxesList?.length > 0 ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-10 mb-16">
          {pageBoxesList?.map((item, index) => {
            return (
              <div
                className={cardClassList[pageBoxesList?.length][index]}
                key={index}
              >
                <IconBoxCardWithImageBelow
                  small={true}
                  icon={item?.icon?.webp}
                  alt={item?.icon?.alt}
                  iconTitle={item?.icon?.title}
                  title={item?.title}
                  info={item?.abstract}
                  btnUrl={item?.externalLink || getSlugURL(item?.internalLink)}
                  target={item?.externalLink ? "_blank" : ""}
                  // btnText={
                  //   index == 0 ? labelsList?.more : labelsList?.contactUs
                  // }
                  btnText={labelsList?.more}
                  image={item?.gallery?.[0].webp}
                />
              </div>
            );
          })}
        </div>
      ) : null}
    </>
  );
};

export default TwoColumnIconBoxCardWithImage;
